import { render, staticRenderFns } from "./GBPhotoAlbumListAlbumHeader.vue?vue&type=template&id=e1f6aa7e&"
import script from "./GBPhotoAlbumListAlbumHeader.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumListAlbumHeader.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumListAlbumHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports